import { useAppSelector } from "../../../store/hooks/useAppSelector";
import { RootState } from "../../../store/types/rootState";
import { IRaffle } from "../../../store/interfaces/IRaffle";
import { BANK_ACCOUNTS, BankAccountItem } from "../../../constants/bankAccounts";
import { banks } from "../../../constants/banks";
import { Bar } from 'react-chartjs-2';
import { Box } from "@mui/material";
import { PURCHASE_ORDER_STATUS } from "../../../constants/purchaseOrderStatus";

interface GeneralProps {
  raffle: IRaffle;
}

export const General = ({ raffle }: GeneralProps) => {
  const accountId = useAppSelector(({ account }: RootState) => account.id);

  return (
   <>
   <Bar
      options={{
        plugins: {
          legend: {
            display: true,
          },
        },
      }}
      data={{
        labels: PURCHASE_ORDER_STATUS.filter(poStatus => poStatus.chart).map(poStatus => poStatus.title),
        datasets: [
          {
            label: 'Estados de verificación',
            data: [1, 2, 4, 12, 23],
            backgroundColor: ['#f44336', '#4caf50', '#ff9800'],
            borderColor: ['#b71c1c', '#1b5e20', '#e65100'],     // Optional: darker border colors
            borderWidth: 1,
          },
        ],
      }}
    />

   </>
  );
};
